import { CookieUtils } from '@space-shell/common/utils/cookie'
import { CookieKeys } from '@space-shell/common/utils/cookie/constants'
import { UAParser } from 'ua-parser-js'

import type { SystemDetailsUtilsReturn } from './types'

const uaParser = new UAParser(navigator.userAgent)

const systemDetails = (): SystemDetailsUtilsReturn => ({
  browser: uaParser.getBrowser(), // browser.name
  device: uaParser.getDevice(), // device.type
  os: uaParser.getOS() // os.name
})

const setCookieCloseBanner = (slug: string) => {
  CookieUtils.setCookie(`${CookieKeys.COOKIE_PWA_BANNER}-${slug}`, 'true')
}

const getCookieCloseBanner = (slug: string) => {
  const cookie = CookieUtils.getCookieByKey(
    document.cookie,
    `${CookieKeys.COOKIE_PWA_BANNER}-${slug}`
  )

  return cookie
}

const handleArrivedFrom = ({ language, slug }) => {
  const lang = language ? language.toLocaleLowerCase() : language
  const opts = [
    {
      name: 'CLUB_HOME',
      route: `/${lang}/club/${slug}`
    },
    {
      name: 'PRODUCT_HOME',
      route: `/${lang}/club/${slug}/products`
    }
  ]

  const arriveFromRoute = opts.find(({ route }) => route === location?.pathname)

  return arriveFromRoute ? arriveFromRoute.name : 'CLUB_HOME'
}

export { systemDetails, getCookieCloseBanner, setCookieCloseBanner, handleArrivedFrom }
